<template>
    <div>
        <div class="row">

            <!-- INICIO DOS CAMPOS DO CADASTRO DO ACOLHIMENTO -->

            <form-select 
                label="Origem da Solicitação" 
                :itens="$root.arrays.acolhimento_origem_solicitacao" 
                v-model="item.origem_solicitacao_id" 
                grid="6"
                :required="true" 
            />
            <form-select 
                label="Unidade solicitante" 
                :itens="unidades"
                v-model="item.unidade_solicitante" 
                grid="6"
                :required="true" 
            />
            <form-select 
                label="Serviço socioassistencial" 
                :itens="servicos"
                v-model="item.servico_socioassistencial_id" 
                :required="true" 
                grid="6"
            />
            <form-input
                label="Nome completo do usuário"
                v-model="item.nome_acolhido"
                :required="true"
                grid="6"
            />
            <form-input 
                label="Nome social" 
                v-model="item.nome_social"
                grid="6"
            />
            <form-input 
                label="Data de nascimento" 
                v-model="item.nascimento" 
                type="date"
                grid="6"
            />
            <form-input 
                label="Número do CPF" 
                v-model="item.cpf" 
                v-mask="'###.###.###-##'"
                grid="6"
            />
            <form-select 
                label="Pessoa com deficiência?" 
                :itens="[{ id: null, value: 'Selecione' }, ...pergunta]" 
                v-model="item.deficiencia" 
                :required="true" 
                grid="6"
            />
            <form-input 
                label="Tipo de Deficiência" 
                v-model="item.tipo_deficiencia" 
                :required="mostrarDeficiencia"
                v-show="mostrarDeficiencia"
                grid="6"
            />
            <form-select 
                label="Gênero" 
                :itens="genero" 
                v-model="item.genero_id" 
                :required="true"
                grid="6"
            />
            <form-select 
                label="Grau de dependência (RDC ANVISA 283/2005)" 
                :itens="dependencia"
                v-model="item.grau_dependencia_id" 
                :required="false"
                v-if="idadeIdoso >= 60"
            />
            <form-select 
                label="Família com presença de criança(s) e/ou adolescente(s)?" 
                :itens="$root.arrays.membros_na_familia" 
                v-model="item.familia_membros" 
                :required="true" 
                :multiple="true"
                grid="6"
            />
            <form-input 
                type="number" 
                v-model="item.qtde_familia_membros" 
                label="Quantidade de crianças e/ou adolescentes a serem vinculados ao Acolhimento?" 
                :required="mostrarQtdeFamiliaFlag"
                v-show="mostrarQtdeFamiliaFlag"
                grid="6"
            />
            <form-select 
                label="Pessoa em situação de rua?" 
                :itens="pergunta" 
                v-model="item.situacao_rua"
                :required="true"
                grid="6"
            />
            <form-input 
                label="Termo Acolhimento"
                v-model="item.termo_acolhimento"
                grid="6"
            />
            <form-calendar 
                label="Data do Acolhimento" 
                v-model="item.data_acolhimento" 
                :required="true" 
                :max-date="dataNow"
                grid="6"
            />
            <form-calendar 
                label="Horário" 
                v-model="item.hora_acolhimento" 
                mode="time"
                grid="6"
            />
            <form-select 
                label="Motivo(s) do Acolhimento:" 
                :itens="$root.arrays.motivos_acolhimento" 
                v-model="item.motivo_acolhimento" 
                :required="true" 
                :multiple="true"
                grid="12"
            />
            <form-input 
                type="text" 
                v-model="item.desc_motivo_acolhimento" 
                label="Descreva o Motivo(s) do Acolhimento:" 
                :required="mostrarMotivoAcolhimento"
                v-show="mostrarMotivoAcolhimento"
                grid="12"
            />

            <!-- FINAL DOS CAMPOS REFERENTE AO CADASTRO DO ACOLHIMENTO -->

            <!-- DEPENDENDO DO PUBLICO ALVO, SERÁ OUTROS CAMPOS A SEREM MOSTRADOS -->

            <template v-if="isIdoso">

                <form-input
                    label="Especifique Outros"
                    v-if="OpenOutros"
                    v-model="item.motivo_outros"
                />

                <form-select
                    v-model="item.acolhimento_anterior"
                    :itens="[{ id: null, value: 'Selecione' }, ...$root.arrays.acolhimento_anterior]"
                    label="Anterior ao acolhimento"
                    grid="6"
                />

                <form-input
                    label="Detalhe da situação anterior"
                    type="text"
                    v-model="item.desc_situacao_anterior"
                    v-show="mostrarSituacaoAnterior"
                    :required="mostrarSituacaoAnterior"
                    maxlength="100"
                />

                <form-select
                    grid="6"
                    label="Reincidência de acolhimento na unidade?"
                    v-model="item.reincidencia"
                    :itens="$root.arrays.reincidencia_acolhimento"
                    :required="true"
                />

                <form-calendar
                    grid="6"
                    label="Data do ultimo acolhimento"
                    v-show="mostrarDataUltimoAcolhimento"
                    v-model="item.data_reincidencia"
                    :max-date="dataNow"
                />

                <form-select
                    grid="6"
                    label="Local de origem"
                    v-model="item.local2_origem"
                    :itens="$root.arrays.acolhimento_local_origem"
                    :required="true"
                />
                
                <form-input
                    grid="6"
                    label="Detalhe do local de origem"
                    v-model="item.desc_local_origem"
                />

                <form-select
                    label="Considerando os motivos do acolhimento, informe quem é / ou são o(s) suposto(s) autor(es) da violência/violação de direitos ou responsável(is) que está(ão)
                    impossibilitado(s) de prestar os cuidados e proteção necessários ao idoso"
                    v-model="item.suposto_ator_violenc"
                    :itens="$root.arrays.acolhimento_suposto_ator_violencia"
                    :required="true"
                    :multiple="true"
                />
                <form-input
                    grid="6"
                    v-model="item.nacionalidade"
                    label="Nacionalidade"
                />
                <form-input
                    grid="6"
                    v-model="item.naturalidade"
                    label="Naturalidade"
                />

                <form-select
                    v-model="item.usu_imigrante"
                    :itens="$root.arrays.pergunta"
                    label="Pessoa ou Família é Migrante/Imigrante?"
                    grid="6"
                />

                <form-select
                    v-model="item.pais_origem"
                    :itens="$root.arrays.paises_acolhimento"
                    label="País de origem"
                    grid="6"
                    :required="mostrarDescImigrante"
                    v-show="mostrarDescImigrante"
                />

                <form-select
                    v-model="item.cor_raca"
                    :itens="$root.arrays.cor_raca_acolhimento"
                    label="Cor ou Raça"
                    grid="6"
                />

                <form-select
                    v-model="item.etnia"
                    :itens="$root.arrays.etnia"
                    label="Etnia"
                    grid="6"
                />

                <form-input
                    grid="6"
                    v-model="item.desc_etnia"
                    label="Descreva a Etnia"
                    :required="mostrarDescOutrasEtnias"
                    v-show="mostrarDescOutrasEtnias"
                />

                <form-input
                    grid="6"
                    v-model="item.desc_indigena"
                    label="Pertence a qual povo indígena?"
                    :required="mostrarDescIndigena"
                    v-show="mostrarDescIndigena"
                />

                <form-input
                    grid="6"
                    v-model="item.desc_quilombola"
                    label="Pertence a qual comunidade quilombola?"
                    :required="mostrarDescQuilombola"
                    v-show="mostrarDescQuilombola"
                />

                <form-input
                    v-model="item.telefone_contato"
                    label="Telefone de contato"
                    sublabel="(pessoa de referência do (a) idoso (a))"
                    grid="6"
                    v-mask="'(##) # ####-####'"
                    placeholder="(00) 0 0000-0000"
                />
                <form-select
                    v-model="item.idoso_interditada"
                    :itens="$root.arrays.idoso_interditada"
                    label="Pessoa Idosa interditada"
                    grid="6"
                />
                <form-input v-model="item.curador" label="Nome curador" grid="6" />
                <form-input
                    v-model="item.curador_contato"
                    label="Contato do curador"
                    grid="6"
                    v-mask="'(##) # ####-####'"
                    placeholder="(00) 0 0000-0000"
                />
                <form-select
                    v-model="item.processo_judicial"
                    :itens="$root.arrays.pergunta"
                    label="Processo Judicial"
                    grid="6"
                />
                <form-select
                    v-model="item.processo_curatela"
                    :itens="$root.arrays.pergunta"
                    label="Pessoa Idosa em processo de curatela"
                    grid="6"
                    :required="true"
                />
                <form-input
                    v-if="item.processo_judicial == 1"
                    v-model="item.numero_processo"
                    label="Se Processo Judicial informar o número de referência"
                />

                <form-select
                    v-model="item.program_medida_protetiva"
                    :itens="$root.arrays.pergunta"
                    label="Pessoa egressa de Programa de Medida Protetiva?"
                    grid="6"
                />

                <form-select 
                    label="Qual violação(s) de direitos vivenciada(s) pelo usuário?" 
                    :itens="$root.arrays.violacoesDireitos" 
                    v-model="item.violacao_direitos" 
                    :required="true" 
                    :multiple="true"
                    grid="12"
                />

            </template>

            <template v-else>

                <form-select
                    v-model="item.acolhimento_anterior"
                    :itens="[{ id: null, value: 'Selecione' }, ...$root.arrays.acolhimento_anterior]"
                    label="Anterior ao acolhimento"
                    grid="6"
                />

                <form-input
                    label="Detalhe da situação anterior"
                    type="text"
                    v-model="item.desc_situacao_anterior"
                    v-show="mostrarSituacaoAnterior"
                    :required="mostrarSituacaoAnterior"
                    maxlength="100"
                />
                
                <form-select
                    grid="6"
                    label="Reincidência de acolhimento na unidade?"
                    v-model="item.reincidencia"
                    :itens="$root.arrays.reincidencia_acolhimento"
                    :required="true"
                />
                <form-calendar
                    grid="6"
                    label="Data do ultimo acolhimento"
                    v-show="mostrarDataUltimoAcolhimento"
                    v-model="item.data_reincidencia"
                    :max-date="dataNow"
                />

                <form-input
                    grid="6"
                    label="Endereço de origem"
                    v-model="item.local_origem"
                />
                <form-select
                    grid="6"
                    label="Local de origem"
                    v-model="item.local2_origem"
                    :itens="$root.arrays.acolhimento_local_origem"
                    :required="true"
                />
                <form-input
                    grid="6"
                    label="Detalhe do local de origem"
                    v-model="item.desc_local_origem"
                />

                <form-select
                    v-model="item.deficiencia_apoio"
                    :itens="$root.arrays.pergunta"
                    label="Em função da deficiência, requer apoio para as atividades diárias?"
                    grid="12"
                    :required="mostrarDeficiencia"
                    v-show="mostrarDeficiencia"
                />

                <form-input
                    v-model="item.telefone_contato"
                    label="Telefone de contato"
                    grid="6"
                    v-mask="'(##) # ####-####'"
                    placeholder="(00) 0 0000-0000"
                />

                <form-select
                    v-model="item.medida_socio_aberto"
                    label="Medida Socioeducativa em Meio Aberto?"
                    grid="6"
                    :itens="$root.arrays.pergunta"
                />

                <form-select
                    v-model="item.estado_civil"
                    label="Estado Civil"
                    grid="6"
                    :itens="$root.arrays.estado_civil"
                />

                <form-input
                    grid="6"
                    v-model="item.nacionalidade"
                    label="Nacionalidade"
                />

                <form-input
                    grid="6"
                    v-model="item.naturalidade"
                    label="Naturalidade"
                />

                <form-select
                    v-model="item.usu_imigrante"
                    :itens="$root.arrays.pergunta"
                    label="Pessoa ou Família é Migrante/Imigrante?"
                    grid="6"
                />

                <form-select
                    v-model="item.pais_origem"
                    :itens="$root.arrays.paises_acolhimento"
                    label="País de origem"
                    grid="6"
                    :required="mostrarDescImigrante"
                    v-show="mostrarDescImigrante"
                />

                <form-select
                    v-model="item.usu_idiomas"
                    :itens="$root.arrays.idiomas"
                    label="Fala qual idiomas?"
                    grid="6"
                    :required="mostrarDescImigrante"
                    v-show="mostrarDescImigrante"
                />

                <form-input
                    grid="6"
                    v-model="item.usu_desc_idiomas"
                    label="Descreva o idioma"
                    :required="mostrarDescImigrante && mostrarDescIdioma"
                    v-show="mostrarDescImigrante && mostrarDescIdioma"
                />

                <form-select
                    v-model="item.cor_raca"
                    :itens="$root.arrays.cor_raca_acolhimento"
                    label="Cor ou Raça"
                    grid="6"
                />

                <form-select
                    v-model="item.etnia"
                    :itens="$root.arrays.etnia"
                    label="Etnia"
                    grid="6"
                />

                <form-input
                    grid="6"
                    v-model="item.desc_etnia"
                    label="Descreva a Etnia"
                    :required="mostrarDescOutrasEtnias"
                    v-show="mostrarDescOutrasEtnias"
                />

                <form-input
                    grid="6"
                    v-model="item.desc_indigena"
                    label="Pertence a qual povo indígena?"
                    :required="mostrarDescIndigena"
                    v-show="mostrarDescIndigena"
                />

                <form-input
                    grid="6"
                    v-model="item.desc_quilombola"
                    label="Pertence a qual comunidade quilombola?"
                    :required="mostrarDescQuilombola"
                    v-show="mostrarDescQuilombola"
                />

                <form-select
                    v-model="item.program_medida_protetiva"
                    :itens="$root.arrays.pergunta"
                    label="Programa de Medida Protetiva"
                    grid="6"
                />

                <form-select 
                    label="Qual violação(s) de direitos vivenciada(s) pelo usuário?" 
                    :itens="$root.arrays.violacoesDireitos" 
                    v-model="item.violacao_direitos" 
                    :required="true" 
                    :multiple="true"
                    grid="12"
                />

            </template>

            <form-textarea-editor
                label="Observação sobre o acolhimento"
                v-model="item.observacao"
            />
            
            <form-select
                v-model="item.status"
                label="Status"
                grid="4"
                :itens="status"
            />
            <form-file
                grid="8"
                @submit="submitFile"
                multiple
                btn-text="Iniciar"
                :progress="progressCompleted"
            />
        </div>
        <search-tecnico
            v-if="carregouTecnicos"
            :key="keyTecnicos"
            :tecnicos.sync="item.tecnicos"
        />
        <div class="row pt-4 px-0 d-flex justify-content-end">
            <form-toggle
                grid="4"
                class="d-flex justify-content-end"
                mt="0"
                v-model="item.privado"
                label="Sigilo?"
            />
            <div class="col-auto px-2 text-right">
                <button
                    class="btn btn-success btn-submit"
                    @click="$emit('submit')"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
        </div>
        <anexos :anexos="item.anexos" />
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            dataNow: moment().format("YYYY/MM/DD"),
            loadingMedidas: false,
            OpenOutros: false,
            medidas: [],
            unidades: [],
            servicos: [],
            files: "",
            status: "",
            mostrarQtdeFamiliaFlag: false,
            progressCompleted: 0,
            pergunta: this.$root.arrays.pergunta,
            genero: this.$root.arrays.genero,
            dependencia: this.$root.arrays.acolhimento_grau_dependencia,
            tecnicos: {},
            tecnicos_selected: null,
            tecnico_temp: "",
            unidade: "",
            loading_tecnicos: false,
            carregouTecnicos: false,
            keyTecnicos: 0,
        };
    },
    mounted() {

        if (this.item.idoso && this.item.idoso.estado_civil) {
            this.item.idoso.estado_civil = parseInt(
                this.item.idoso.estado_civil
            );
        }

        this.getStatus();
        this.getUnidades();
        this.getServicos();
        this.prepararTecnicos();

        if (
            this.item.deficiencia === null ||
            this.item.deficiencia === undefined ||
            this.item.deficiencia === 0 ||
            this.item.deficiencia === "0"
        ) {
            this.item.deficiencia = null;
        } else {
            this.item.deficiencia = Number(this.item.deficiencia);
        }

        if (!Array.isArray(this.item.motivo_acolhimento)) {
            if (typeof this.item.motivo_acolhimento === "string") {
                try {
                    this.item.motivo_acolhimento = JSON.parse(this.item.motivo_acolhimento);
                } catch (e) {
                    this.item.motivo_acolhimento = [];
                }
            } else {
                this.item.motivo_acolhimento = [];
            }
        }

        // Converter valores para números
        this.item.motivo_acolhimento = this.item.motivo_acolhimento.map(Number);

        if (this.item.desc_motivo_acolhimento == "null") {

            this.item.desc_motivo_acolhimento = "";
            
        }

        if (this.item.familia_membros) {
            if (typeof this.item.familia_membros === "string") {
                // Se veio string, transforma em array com 1 item
                this.item.familia_membros = [this.item.familia_membros];
            } else if (!Array.isArray(this.item.familia_membros)) {
                // Se veio outro formato, força vazio
                this.item.familia_membros = [];
            }
        } else {
            this.item.familia_membros = [];
        }

        if (!this.item.acolhimento_anterior || this.item.acolhimento_anterior === 0) {
            this.item.acolhimento_anterior = null;
        }

    },
    watch: {
        'item.deficiencia'(novoValor) {
            if (Number(novoValor?.id ?? novoValor) !== 1) {
                this.item.tipo_deficiencia = null;
            }
        },
        'item.acolhimento_anterior'(novoValor) {
            if (novoValor !== 9) {
                this.item.desc_situacao_anterior = null;
            }
        },
        'item.reincidencia'(novoValor) {
            if (novoValor !== 1) {
                this.item.data_reincidencia = null;
            }
        },
        'item.usu_imigrante'(novoValor) {
            if (novoValor !== 1) {
                this.item.pais_origem = null;
                this.item.usu_idiomas = null;
                this.item.usu_desc_idiomas = null;
            }
        },
        'item.usu_idiomas'(novoValor) {
            if (novoValor !== 7) {
                this.item.usu_desc_idiomas = null;
            }
        },
        'item.etnia'(novoValor) {  

            // Se etnia não for indígena, zera o campo  
            if (novoValor !== 1 && novoValor?.id !== 1) {  
                this.item.desc_indigena = null; 
            } 

            // Se etnia não for quilombola, zera o campo
            if (novoValor !== 2 && novoValor?.id !== 2) {
                this.item.desc_quilombola = null;
            }

            // Se etnia não for "outras", zera o campo
            if (novoValor !== 3 && novoValor?.id !== 3) {
                this.item.desc_etnia = null;
            }
        },
        'item.familia_membros': {
            handler() {
                this.mostrarQtdeFamiliaFlag = this.mostrarQtdeFamilia;
            },
            immediate: true,
            deep: true,
        },
        idadeIdoso(novaIdade) {
            if (novaIdade < 60) {
                this.item.grau_dependencia_id = null;
            }
        }
    },
    computed: {
        mostrarSituacaoAnterior() {
            return this.item.acolhimento_anterior === 9;
        },
        mostrarDataUltimoAcolhimento () {
            return this.item.reincidencia === 1;
        },
        mostrarDeficiencia() {
            const deficiencia = this.item.deficiencia;

            return Number(deficiencia?.id ?? deficiencia) === 1;
        },
        mostrarDescImigrante() {
            const usu_imigrante = this.item.usu_imigrante;
            return usu_imigrante === 1 || (usu_imigrante?.id === 1);
        },
        mostrarDescIdioma() {
            const usu_idiomas = this.item.usu_idiomas;
            return usu_idiomas === 7 || (usu_idiomas?.id === 7);
        },
        mostrarDescOutrasEtnias() {
            const etnia = this.item.etnia;
            return etnia === 3 || (etnia?.id === 3);
        },
        mostrarDescIndigena() {
            const etnia = this.item.etnia;
            return etnia === 1 || (etnia?.id === 1);
        },
        mostrarDescQuilombola() {
            const etnia = this.item.etnia;
            return etnia === 2 || (etnia?.id === 2);
        },
        idadeIdoso() {
            if (!this.item.nascimento) return 0;

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            return hoje.diff(nascimento, "years");
        },
        mostrarMotivoAcolhimento() {
            const motivo = this.item.motivo_acolhimento;

            if (!Array.isArray(motivo)) return false;

            return motivo.some(opcao => opcao === 19 || opcao.id === 19);
        },
        mostrarQtdeFamilia() {
            if (!Array.isArray(this.item.familia_membros)) return false;
            // Mostra se algum id diferente de "0"
            return this.item.familia_membros.some(id => id !== "0");
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');
            
            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
    },
    methods: {

        prepararTecnicos() {
            if (!this.item.tecnicos) {
                this.item.tecnicos = [];
            }

            if (typeof this.item.tecnicos === "string") {
                try {
                    this.item.tecnicos = JSON.parse(this.item.tecnicos);
                } catch (e) {
                    this.item.tecnicos = [];
                }
            }

            if (!Array.isArray(this.item.tecnicos)) {
                this.item.tecnicos = [];
            }

            this.item.tecnicos = this.item.tecnicos
                .map((tecnico) => {
                    if (typeof tecnico === "object" && tecnico !== null) {
                        return Number(tecnico.id);
                    }

                    return Number(tecnico);
                })
                .filter((tecnico) => !isNaN(tecnico));

            this.carregouTecnicos = true;
            this.keyTecnicos++;
        },

        getServicos() {
            axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
                this.servicos = response.data;
            });
        },

        getUnidades() { 
            this.load = true;
            axios.get("api/dashboard/unidades").then((response) => {
                this.unidades = response.data.data.map((item) => ({
                    id: item.id,
                    value: item.nome
                }));
            });
        },

        submitFile(files) {
            this.files = files;
            let formData = new FormData();
            for (const i of Object.keys(this.item)) {
                formData.append(i, this.item[i]);
            }
            // 	if (i == "anexos") {
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }
            // this.$emit("files", files);
            axios
                .post(`api/dashboard/acolhimento/upload`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .finally(() => {
                    this.$emit("submit");
                    this.progressCompleted = 0;
                });
        },
        checkMotivo(itens) {
            if (itens) {
                let isMotivo = false;
                itens.forEach((elem) => {
                    if (elem == 5) {
                        isMotivo = true;
                    }
                });
                this.OpenOutros = isMotivo ? true : false;
            }
        },
        getStatus() {
            axios.get(`api/dashboard/status/acolhimento`).then((response) => {
                this.status = response.data;
            });
        },
    },
};
</script>
